import queryString from 'query-string';
import { STATES } from './constants';
export const changeStateHelper = state => ({
    isProcessing: state === STATES.PENDING,
    isProcessed: state === STATES.SYNCED,
    isProcessingFailed: state === STATES.FAILED,
    isStale: state === STATES.STALE,
});
export const changeMeta = ({ state, verb, code, error }) => ({
    __STATE__: state,
    __VERB__: verb,
    __CODE__: code,
    __TIMESTAMP__: Date.now(),
    __ERROR__: error,
    ...changeStateHelper(state, verb),
});
export function sortedStringify(query) {
    if (query) {
        const keys = Object.keys(query).sort();
        const sortedObject = {};
        keys.forEach(key => {
            sortedObject[key] = query[key];
        });
        return queryString.stringify(sortedObject);
    }
    return '';
}
export function getKey(options) {
    const { id, query } = options;
    const qs = query ? sortedStringify(query) : '';
    if (qs.length > 0) {
        return `${id}::${qs}`;
    }
    return id;
}
//# sourceMappingURL=utils.js.map